import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { Grid, Typography, TextField } from '@material-ui/core'

const Header = () => {
  const { control, errors } = useFormContext()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Título e Subtítulo</Typography>
      </Grid>
      <Grid item xs={12}>
        <Controller
          as={
            <TextField
              label="Título"
              variant="outlined"
              fullWidth
              multiline
              error={!!errors?.pageTitle}
              helperText={errors?.pageTitle?.message}
            />
          }
          name="pageTitle"
          control={control}
        />
      </Grid>

      <Grid item xs={12}>
        <Controller
          as={
            <TextField
              label="Subtítulo"
              variant="outlined"
              fullWidth
              multiline
              error={!!errors?.pageSubtitle}
              helperText={errors?.pageSubtitle?.message}
            />
          }
          name="pageSubtitle"
          control={control}
        />
      </Grid>
    </Grid>
  )
}

export default Header
